import { useState } from 'react';
import { User } from 'lucide-react';

interface AvatarProps {
  src?: string | null;
  alt?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  border?: boolean;
}

const sizes = {
  xs: 'w-8 h-8 min-w-[32px] min-h-[32px]',
  sm: 'w-10 h-10 min-w-[40px] min-h-[40px]',
  md: 'w-12 h-12 min-w-[48px] min-h-[48px]',
  lg: 'w-16 h-16 min-w-[64px] min-h-[64px]',
  xl: 'w-20 h-20 min-w-[80px] min-h-[80px]',
};

const iconSizes = {
  xs: 14,
  sm: 18,
  md: 22,
  lg: 28,
  xl: 36,
};

export default function Avatar({
  src,
  alt = 'Avatar',
  size = 'md',
  className = '',
  border = true,
}: AvatarProps) {
  const [hasError, setHasError] = useState(false);

  const showFallback = !src || hasError;

  return (
    <div
      className={`
        ${sizes[size]}
        rounded-full overflow-hidden flex-shrink-0
        ${border ? 'ring-2 ring-white/20' : ''}
        ${showFallback ? 'bg-white/10 flex items-center justify-center' : ''}
        ${className}
      `}
      style={{ aspectRatio: '1 / 1' }}
    >
      {showFallback ? (
        <User size={iconSizes[size]} className="text-white/40" />
      ) : (
        <img
          src={src}
          alt={alt}
          onError={() => setHasError(true)}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      )}
    </div>
  );
}
